var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.0514 116.481C8.3175 113.747 8.3175 109.315 11.0514 106.582L53.5319 64.1009L11.0504 21.6193C8.31653 18.8857 8.31653 14.4534 11.0504 11.7198L11.7194 11.0505C14.4532 8.31682 18.8854 8.31682 21.6193 11.0505L64.1007 53.5322L106.583 11.0503C109.316 8.31657 113.748 8.31657 116.482 11.0502L117.151 11.7195C119.885 14.4533 119.885 18.8854 117.151 21.6191L74.6696 64.1009L117.151 106.582C119.884 109.315 119.884 113.748 117.151 116.481L116.481 117.151C113.748 119.884 109.316 119.884 106.582 117.151L64.1007 74.6697L21.6198 117.15C18.8864 119.884 14.4542 119.884 11.7203 117.15L11.0514 116.481Z","fill":"#333333"}));
}

Cross.defaultProps = {"width":"128","height":"128","viewBox":"0 0 128 128","fill":"none"};

module.exports = Cross;

Cross.default = Cross;
